<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#fff" text-color="#000" active-text-color="#000">
      <div class="menu_top">
        <div class="left_box">
          <div>
            <el-button class="buttonimg">
              <i class="showimg" :class="collapsed ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
                @click="toggle(collapsed)"></i>
            </el-button>
          </div>
          <div v-if="screenWidth">
            <record></record>
          </div>
        </div>
        <div class="right_box">
          <!-- <automaticReply></automaticReply> -->
          <changeLang></changeLang>
          <div>
            <el-tooltip :content="$t('header.Fullscreen')" effect="dark" placement="bottom" fullscreen>
              <img class="qp_img" :src="imgqp" @click="isScreenFull" />
            </el-tooltip>
          </div>
          <div class="right-bread">
            <el-dropdown @command="clickDropdown">
              <span class="el-dropdown-link">
                <!-- <img class="my_img" :src="imgmy"> -->
                {{ userNickName }}
                <img class="my_img" :src="imgmy" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">{{ $t('header.Setting') }}</el-dropdown-item>
                <el-dropdown-item command="2">{{ $t('header.Logout') }}</el-dropdown-item>
                <el-dropdown-item command="3">v1.0.0</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- <template slot="title">{{ platformTitle }}</template> -->
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import record from "./record";
//引入全屏插件
import screenfull from "screenfull";
import changeLang from "./changeLang.vue";
import automaticReply from "./automaticReply.vue";
export default {
  name: "topheader",
  data() {
    return {
      collapsed: true,
      imgmy: require("../assets/img/my.png"),
      imgqp: require("../assets/img/qp.png"),
      screenWidth: true
    };
  },
  components: {
    record,
    changeLang,
    automaticReply
  },
  computed: {
    ...mapGetters(["nickname", "realName", "platformName"]),
    userNickName: {
      get() {
        return this.realName || this.nickname;
      },
    },
    platformTitle: {
      get() {
        return this.platformName ? this.platformName : this.$t('login.formatName');
      },
    },
  },

  // 创建完毕状态(里面是操作)
  created() {
    // 监听窗口改变后改变
    this.$root.Bus.$on("screenWidth", (value) => {
      this.screenWidth = value < 1400 ? false : true;
      if (value <= 1400) {
        this.toggle(true);
      }
    });
  },
  methods: {
    //全屏方法
    isScreenFull() {
      // 需要注意的是 如果判断!screenfull.enabled 显示的是不支持全屏的话 是因为谷歌的版本问题  判断改为 !screenfull.isEnabled  就可以了

      if (!screenfull.isEnabled) {
        // 如果不支持进入全屏，发出不支持提示
        this.$message({
          message: this.$t("header.FullscreenMessage"),
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
    },

    clickDropdown(command) {
      switch (command) {
        case "1":
          this.toSetting();
          break;
        case "2":
          this.exit();
          break;
      }
    },
    toSetting() {
      this.$router.push({ name: "personalSettings" });
    },
    // 退出登录
    exit() {
      this.$confirm(this.$t('header.logoutMessage'), this.$t('header.Tip'), {
        confirmButtonText: this.$t('header.confirm'),
        cancelButtonText: this.$t('header.cancel'),
        type: "warning",
        center: true,
      })
        .then(async () => {
          try {
            await this.$store.dispatch("user/deleteUserInfo", this.nickname);
          } finally {
            await this.$store.dispatch("user/logout");
            // 刷新页面
            location.reload();
          }
        })
        .catch(() => { });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  height: 50px;
}

.el-dropdown-link {
  font-size: 16px;
  color: #252525;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.menu_top{
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
}

.left_box {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
}

.right_box {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
} 
.right_box>div {
  /* padding: 0 20px 0 0; */
  margin-right: 30px;
}

.my_img {
  background-color: #c0c4cc;
  width: 20px;
  height: 20px;
  padding: 5px;
  border-radius: 50%;
  /* transform: translateY(8px); */
  margin-left: 5px;
  box-sizing: border-box;
}

.qp_img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  cursor: pointer;
}

/deep/ .el-submenu__title {
  height: 50px;
}

.buttonimg {
  height: 50px !important;
  border: none;
  padding: 0 10px;
  font-size: 20px;
}

.showimg:active {
  border: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px;
  z-index: 999;
}

.topSpan {
  display: inline-block;
  float: left;
  text-align: left;
  padding-left: 15px;
  color: white;
  font-size: 20px;
  height: 50px;
  line-height: 50px;
}

.topSpan:focus {
  outline: none;
}

.el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid transparent;
  color: #fff;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/topheader.vue